module.exports = __webpack_public_path__ + "VAGRoundedStd-Light.26278fb76f1684f9a472.svg";


//////////////////
// WEBPACK FOOTER
// /var/www/minhaloga-cliente/src/app/@theme/fontes/fonte-vag-rounded/VAGRoundedStd-Light.svg
// module id = ../../../../../src/app/@theme/fontes/fonte-vag-rounded/VAGRoundedStd-Light.svg
// module chunks = styles